import React from 'react';
import { Box, Typography } from '@mui/material';
import Header from '../../../../components/header';
import ParentWrapper from '../../../../components/ParentWrapper';

// Placeholder for the upcoming Nippon-Bot-only interactions view.
// Wire this up to nipponBotApiEndpoints.interactionsList /
// interactionsFilterDetails once the UI for it is designed.
export default function NipponBotInteractions() {
  return (
    <ParentWrapper sx={{ minHeight: "calc(100vh - 45px)" }}>
      <Header title="Interactions" subtitle="Nippon Bot interaction records" />
      <Box sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Coming soon.
        </Typography>
      </Box>
    </ParentWrapper>
  );
}
